module.exports = __webpack_public_path__ + "img/icon17.1dc0feb8.png";